<div id='hes-header'>{{trans('systems.titles.events')}}</div>
<div *ngFor='let iEvent of visibleEvents' class='hes-event' (click)="openEvents()">
    <div class="hes-event-icon" [inlineSVG]="reactions.getReactionIcon(iEvent.reaction)"></div>
    <div class="hes-event-title {{iEvent.isAreaEvent ? '' : 'hes-event-title_no_area'}}" >{{iEvent.title}}</div>
    <div *ngIf='iEvent.isAreaEvent && iEvent.areaId !== 0' class="hes-event-area" >{{iEvent.areaText}}</div>
    <div class="hes-event-time" ><span>{{dt.formatTimeFromNumber(iEvent.time)}}</span><span> {{dt.formatDateFromNumber(iEvent.time * 1000)}}</span></div>
</div>